import styled from 'styled-components';
import { colorThemes } from '../../../stylesheets/themes';
import { getFixedSpace, hideVisually, emulateFocus } from '../../../stylesheets/tools';

const StyledRadioButton = styled.div`
  display: inline-block;
  margin: ${getFixedSpace('xxs')} ${getFixedSpace('xs')} ${getFixedSpace('xxs')}
    ${getFixedSpace('xxs')};

  .radioButton__wrapper {
    cursor: pointer;
    display: inline-flex;
    justify-content: baseline;
    align-items: flex-end;
  }

  .radioButton__custom-radio {
    position: relative;
    margin-right: ${getFixedSpace('xxs')};
  }

  .radioButton__shape {
    stroke: ${props => (props.color ? colorThemes[props.color].primary : '#000')};
  }

  .radioButton__check {
    display: none;
    position: absolute;
    width: 0;
    height: 0;
    border-bottom: 16px solid
      ${props => (props.color ? colorThemes[props.color].secondary : '#000')};
    border-left: 16px solid transparent;
    bottom: 4px;
    right: 4px;
  }

  .radioButton__label {
    color: ${props => (props.color ? colorThemes[props.color].primary : '#000')};
    font-weight: 400;
    font-size: 18px;
    line-height: 18px;
  }

  input {
    ${hideVisually()}
  }

  input:checked ~ .radioButton__custom-radio .radioButton__check {
    display: block;
  }

  [data-whatinput='keyboard'] & input:focus ~ .radioButton__custom-radio {
    ${emulateFocus()};
  }
`;

export default StyledRadioButton;
